import { NgModule } from '@angular/core';
import { KrakenContextualMenuComponent } from './kraken-contextual-menu.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    KrakenContextualMenuComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KrakenContextualMenuComponent
  ]
})
export class KrakenContextualMenuModule { }
